<template>
    <div class="animated fadeIn">
        <div v-if="!addAreaMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <b-button v-on:click="goBack" variant="secondary">
                        <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <h1>{{groupTitle}}</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <b-btn class="header-collapse" block href="#" v-b-toggle.mainDetails @click="showGroupDetails = !showGroupDetails">
                                <strong>Group Details &nbsp;<i :class="showGroupDetails ? 'fa fa-compress font-lg' : 'fa fa-expand font-lg'"></i></strong>
                            </b-btn>
                            <!-- <strong>Group Details</strong> -->
                        </div>
                        <div v-if="!groupInfoLoaded" class="form-container">
                            <LoadingSpinner />
                        </div>
                        <b-collapse id="mainDetails" accordion="details" role="tabpanel"  v-model="showGroupDetails">
                            <div v-if="groupInfoLoaded" class="form-container">
                                <b-row>
                                    <b-col sm="6">
                                        <b-form-group>
                                            <label for="groupName">Name</label>
                                            <b-form-input v-model="group.company_name" type="text" id="groupName"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-form-group>
                                            <label for="groupShortName">Short Name</label>
                                            <b-form-input v-model="group.company_short_name" type="text" id="groupShortName"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-form-group>
                                            <label for="groupSubDomain">Sub-domain</label>
                                            <b-form-input v-model="group.sub_domain" type="text" id="groupSubDomain"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="6">
                                        <b-form-group>
                                            <label for="groupContactNumber">Main Contact Number</label>
                                            <b-form-input v-model="group.main_contact_number" type="text" id="groupContactNumber"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="6">
                                        <b-form-group>
                                            <label for="groupEmail">Main Email Address</label>
                                            <b-form-input v-model="group.main_email" type="text" id="groupEmail"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="12">
                                        <b-form-group>
                                            <label for="groupAddress">Address</label>
                                            <b-form-input v-model="group.main_address" type="text" id="groupAddress"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="3">
                                        <b-form-group>
                                            <label for="groupTown">Town</label>
                                            <b-form-input v-model="group.main_town" type="text" id="groupTown"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-form-group>
                                            <label for="groupPostCode">Post Code</label>
                                            <b-form-input v-model="group.main_post_code" type="text" id="groupPostCode"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-form-group>
                                            <label for="groupCounty">County</label>
                                            <b-form-select id="groupCounty" v-model="group.county_id"
                                                :plain="true"
                                                :options="counties">
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-form-group>
                                            <label for="groupCountry">Country</label>
                                            <b-form-select id="groupCountry" v-model="group.country_id"
                                                :plain="true"
                                                :options="countries">
                                            </b-form-select>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="6">
                                        <b-form-group>
                                            <label for="groupLicence">Licence</label>
                                            <b-form-input v-model="group.licence_id" type="text" id="groupLicence"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-form-group>
                                            <label for="groupIsSAP">SAP group?</label><br/>
                                            <b-button class="toggle-option-button" variant="outline-primary" @click="setIsSAP(group.is_sap)">
                                                {{group.is_sap === '1' ? 'Yes' : 'No'}}
                                            </b-button>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-form-group>
                                            <label for="groupIsActive">Is Active?</label><br />
                                            <b-button class="toggle-option-button" variant="outline-primary" @click="setIsActive(group.is_active)">
                                                {{group.is_active === '1' ? 'Yes' : 'No'}}
                                            </b-button>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="4">
                                        <b-form-group>
                                            <label for="areaLogo">Upload Logo</label>
                                        <input type="file"
                                                :name="group.logo"
                                                :disabled="!allowSave"
                                                @change="filesChange($event.target.name, $event.target.files)"
                                                @size-exceeded="onGroupLogoSizeExceeded"
                                                fileCount ="$event.target.files.length"
                                                accept="image/*" class="input-file">
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="this.$data.userAuthLevel == 'Super Admin'">
                                    <b-col>
                                        <b-form-group>
                                            <label for="groupNotes">Notes</label>
                                            <b-form-textarea v-model="group.notes" rows="5" id="groupNotes"></b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr />
                                <b-row v-if="this.$data.userAuthLevel == 'Super Admin'">
                                    <b-col cols="12" sm="12" md="12">
                                        <p class="action-button-toolbar">
                                            <b-button v-on:click="updateGroup" variant="primary" :disabled="!allowSave">
                                                <i class="fa fa-check"></i>&nbsp;Update Group
                                            </b-button>
                                            <b-button v-if="isUserSuperAdmin" v-on:click="deleteGroup" variant="danger" :disabled="!allowSave">
                                                <i class="fa fa-trash"></i>&nbsp;Delete Group
                                            </b-button>
                                        </p>
                                        <b-alert v-if="groupSaveSuccess" variant="success" show><strong>Data saved successfully.</strong></b-alert>
                                        <b-alert v-if="groupSaveError" variant="danger" show><strong>Error saving data. Please try again.</strong></b-alert>
                                        <b-alert v-if="groupSaveInProgress" variant="info" show><strong>Saving data. Please wait...</strong></b-alert>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-collapse>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Associated Areas</strong>
                        </div>
                        <div v-if="!areasLoaded" class="form-container">
                            <LoadingSpinner />
                        </div>
                        <div v-if="areasLoaded" class="form-container">
                            <b-row v-if="!isUserReadOnly">
                                <b-col cols="12" sm="12" md="6">
                                    <p>
                                        <b-button v-on:click="enterAddAreaMode" variant="primary">
                                            <i class="fa fa-plus"></i>&nbsp;Add Area
                                        </b-button>
                                    </p>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col v-for="area in areas" cols="12" sm="12" md="6" v-bind:key="area.id">
                                    <b-card :no-body="true" footer-class="px-3 py-2" :class="getActiveCardStatusClass(area)">
                                        <b-card-body class="p-3 clearfix">
                                            <img v-if="area.logo" v-bind:src="getLogo(area.logo)" width="64px" class="mr-3 float-left" />
                                            <i v-if="!area.logo" :class="getActiveStatusClass(area)" class="fa fa-map-o p-3 font-2xl mr-3 float-left"></i>
                                            <div class="h5 text-warning mb-0 mt-2">{{area.area_name}}</div>
                                            <div class="text-muted text-uppercase font-weight-bold font-xs">{{area.address}}, {{area.post_code}}</div>
                                            <div class="text-muted text-uppercase font-weight-bold font-xs">Status: <span :class="getActiveStatusForeColourClass(area)"> {{area.is_active == "1" ? 'Active' : 'Inactive'}}</span></div>
                                            <b-button class="toggle-group-button" variant="outline-primary" @click="confirmActiveState(area.id)">
                                                {{area.is_active == '1' ? 'Disable' : 'Enable'}}
                                            </b-button>
                                        </b-card-body>
                                        <div slot="footer">
                                            <b-link class="font-weight-bold font-xs btn-block text-muted" v-bind:href="'/#/group/' + groupParamName + '/' + area.page_slug">View More <i class="fa fa-angle-right float-right font-lg"></i></b-link>
                                        </div>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="addAreaMode" class="viewMode">
            <b-row>
                <b-col cols="12">
                    <b-button v-on:click="exitAddAreaMode" variant="secondary">
                        <i class="fa fa-arrow-circle-left"></i>&nbsp;Back
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <h1>Add New Area</h1>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-card>
                        <div slot="header">
                            <strong>Area Details</strong>
                        </div>
                        <div class="form-container">
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="areaName">Name</label>
                                        <b-form-input v-model="newArea.area_name" type="text" id="areaName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="areaContactFirstName">Contact First Name</label>
                                        <b-form-input v-model="newArea.contact_first_name" type="text" id="areaContactFirstName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="areaContactLastName">Contact Last Name</label>
                                        <b-form-input v-model="newArea.contact_last_name" type="text" id="areaContactLastName"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="areaEmail">Contact Email</label>
                                        <b-form-input v-model="newArea.email" type="text" id="areaEmail"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="areaContactNo">Contact No</label>
                                        <b-form-input v-model="newArea.contact_no" type="text" id="areaContactNo"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="areaAddress">Address</label>
                                        <b-form-input v-model="newArea.address" type="text" id="areaAddress"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="6">
                                    <b-form-group>
                                        <label for="areaTown">Town</label>
                                        <b-form-input v-model="newArea.post_town" type="text" id="areaTown"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="areaCounty">County</label>
                                        <div v-if="!countiesLoaded">
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                        <b-form-select id="areaCounty" v-if="countiesLoaded" v-model="newArea.county_id"
                                            :plain="true"
                                            :options="counties">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="areaPostCode">Post Code</label>
                                        <b-form-input v-model="newArea.post_code" type="text" id="areaPostCode"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="areaCountry">Country</label>
                                        <div v-if="!countriesLoaded">
                                            <i class="fa fa-spin fa-spinner"></i>
                                        </div>
                                        <b-form-select id="areaCountry" v-if="countriesLoaded" v-model="newArea.country_id"
                                            :plain="true"
                                            :options="countries">
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                  <b-form-group>
                                        <label for="areaLogo">Upload Logo</label>
                                        <input type="file"
                                             :name="newArea.logo"
                                             :disabled="!allowSave"
                                             @change="filesAreaChange($event.target.name, $event.target.files)"
                                             @size-exceeded="onLogoSizeExceeded"
                                             fileCount ="$event.target.files.length"
                                            accept="image/*" class="input-file">
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr />
                            <b-row>
                                <b-col cols="12" sm="12" md="12">
                                    <p>
                                        <b-button v-on:click="saveArea" variant="primary" :disabled="!allowAreaSave">
                                            <i class="fa fa-check"></i>&nbsp;Save Area
                                        </b-button>
                                    </p>
                                    <b-alert v-if="areaSaveError" variant="danger" show><strong>Error saving data. Please try again.</strong></b-alert>
                                    <b-alert v-if="areaSaveInProgress" variant="info" show><strong>Saving data. Please wait...</strong></b-alert>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
          <b-modal title="Confirm Active Status Change" class="modal-warning" v-model="activeStateModal" @ok="toggleActiveState" ok-variant="warning">
            <p>
                Are you sure you wish to change the active status?
            </p>
            <p>
                Continuing will also changes the status of all areas, sites and users under this group.
            </p>
        </b-modal>
    </div>
</template>

<script>

import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import { Switch as cSwitch } from '@coreui/vue'
import { Promise } from 'q';
import { constants } from 'fs';
import VueBase64FileUpload from 'vue-base64-file-upload';
import {loadFile} from "../../shared/utils";

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    let headerConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
        }
    }
    return headerConfig;
}

const getCompanyInfo = (($http, slug) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
         $http.get('company/slug/' + slug, headersObj)
            .then((response) => {
                console.log('From promise: ', response);
                // let comps = response.data.companies.filter((element) => {
                //     return element.company_short_name == shortname;
                // });
                //let thisco=response.data.company[0];
                resolve(response.data.company);
                console.log('Company: '+response.data.company);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getCompanyInfoById = (($http, companyId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get('company/' + companyId, headersObj)
            .then((response) => {
                resolve(response.data.company);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getAreas = (($http, companyId) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
         $http.get('area?company_id=' + companyId, headersObj)
            .then((response) => {
                resolve(response.data);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getCounties = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("getCountiesForSelect", headersObj)
            .then((response) => {
                resolve(response.data);
                console.log(response.data);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getCountries = (($http) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("getCountriesForSelect", headersObj)
            .then((response) => {
                resolve(response.data);
                console.log(response.data);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

const getParams = (($http, $route) => {
    return new Promise((resolve, reject) => {
        let groupParam = $route.params.groupshortname;
        if (groupParam === undefined) {
            let userObj = JSON.parse(localStorage.getItem('user'));
            getCompanyInfoById($http, userObj.company_id)
                .then((company) => {
                    groupParam = company.page_slug;
                    resolve(groupParam);
                })
                .catch ((err) => {
                    console.error(err);
                    reject(err);
                });
        }
        else {
            resolve(groupParam);
        }
    });
});

export default {
    name: 'group',

    components: {
        LoadingSpinner: LoadingSpinner,
        cSwitch,
        VueBase64FileUpload
    },
  data () {
    return {
        showGroupDetails: false,
        groupInfoLoaded: false,
        groupSaveSuccess: false,
        groupSaveError: false,
        groupSaveInProgress: false,
        allowSave: true,
        areasLoaded: false,
        group: {},
        areas: [],
        counties: [],
        countries: [],
        groupTitle: "",
        groupParamName: "",
        newArea: {
            area_name: '',
            contact_first_name: '',
            contact_last_name: '',
            contact_no: '',
            email: '',
            address: '',
            post_code: '',
            post_town: '',
            county_id: 0,
            country_id: 0,
            logo: null
        },
        addAreaMode: false,
        countiesLoaded: false,
        countriesLoaded: false,
        allowAreaSave: true,
        areaSaveError: false,
        areaSaveInProgress: false,
        userAuthLevel: '',
        activeStateModal: false,
        areaIdToChangeActiveStatus: 0
    }
  },
  created () {
    getParams(this.$http, this.$route)
        .then((params) => {
            this.$data.groupParamName = params;
            console.log(params);
            return this.getCurrentUser();
        })
        .then((userDetails) => {
            this.$data.userAuthLevel = userDetails.auth;
            return getCounties(this.$http);
        })
        .then((response) => {
            this.$data.counties = response.counties;
            return getCountries(this.$http)
        })
        .then((response) => {
            this.$data.countries = response.countries;
            return getCompanyInfo(this.$http, this.$data.groupParamName);
        })
        .then((companyData) => {
            this.$data.group = companyData;
            this.$data.groupTitle = companyData.company_name;
            this.$data.groupInfoLoaded = true;
            return getAreas(this.$http, companyData.id);
        })
        .then((areaData) => {
            this.$data.areas = areaData.areas;
            this.$data.areasLoaded = true;
        })
        .catch ((err) => {
            console.error(err);
        });
  },
  computed: {
    isUserReadOnly() {
        console.log(this.$data.userAuthLevel);
        if (this.$data.userAuthLevel == 'Read Only') {
            return true;
        }
        else {
            return false;
        }
    },
    isUserSuperAdmin() {
        if (this.$data.userAuthLevel == 'Super Admin') {
            return true;
        }
        else {
            return false;
        }
    },
  },
  methods : {
    getLogo (fileName) {
        return loadFile(fileName)
    },
    confirmActiveState(branchId) {
        // get confirmation of active/inactive
        this.$data.areaIdToChangeActiveStatus = branchId;
        this.$data.activeStateModal = true;
    },
    toggleActiveState() {
        // marks the company active or inactive
        // plus all that is under it is marked active/inactive

        this.$data.activeStateModal = false;
        this.updateArea();
    },
    updateArea() {

        // get the area data
        let area = {};

        this.$data.areas.forEach((element) => {
            if (element.id === this.$data.areaIdToChangeActiveStatus) {
                area = element;
            }
        });

        let newActiveStatus = 0;
        if (area.is_active === '0' || area.is_active === 0 || area.is_active === false) {
            newActiveStatus = 1;
        }

        let headersObj = getHTTPHeaders();

        const formData = new FormData();
        let payload =  {
            id: area.id,
            area_name: area.area_name,
            contact_first_name: area.contact_first_name,
            contact_last_name: area.contact_last_name,
            contact_no: area.contact_no,
            email: area.email,
            address: area.address,
            post_code: area.post_code,
            post_town: area.post_town,
            county_id: area.county_id,
            country_id: area.country_id,
            is_active: newActiveStatus,
            logo: area.logo
        }

        for (let key in payload) {
          formData.append(key, payload[key])
        }

        formData.append('_method', 'PUT');

        this.$http.post('area/'+area.id,formData, headersObj)
        .then((response) => {
            console.log(response.data);
            if (response.data.success === true) {
                this.$data.areaSaveInProgress = false;
                this.$data.areaSaveSuccess = true;
            }
            this.$data.areasLoaded = false;
            return getAreas(this.$http, this.$data.group.id);
        })
        .then((areaData) => {
            this.$data.areas = areaData.areas;
            this.$data.areasLoaded = true;
        })
        .catch ((err) => {
            console.error(err);
            this.$data.areaSaveInProgress = false;
            this.$data.areaSaveError = false;
        });
    },
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    onGroupLogoFile() {
        console.log('on logo file');
    },
    filesChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.$data.group.logo = fileList[0]
    },
    filesAreaChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.$data.newArea.logo = fileList[0]
    },
    onGroupLogoLoad(dataUri) {
        console.log('on logo load');
        this.$data.group.logo = dataUri;
    },
    onGroupLogoSizeExceeded() {
        console.log('on logo exceed');
    },
    onLogoFile() {
        console.log('on logo file');
    },
    onLogoLoad(dataUri) {
        console.log('on logo load');
        this.$data.newArea.logo = dataUri;
    },
    onLogoSizeExceeded() {
        console.log('on logo exceed');
    },
    getActiveStatusClass(area) {
        return area.is_active == "1" ? 'bg-success' : 'bg-danger';
    },
    getActiveStatusForeColourClass(group) {
        return group.is_active == "1" ? 'group-active' : 'group-disabled';
    },
    getActiveCardStatusClass(area) {
        return area.is_active != "1" ? 'inactive-card' : '';
    },
    goBack() {
        this.$router.go(-1);
    },
    clearAlerts() {
        this.$data.groupSaveSuccess = false;
        this.$data.groupSaveError = false;
        this.$data.groupSaveInProgress = false;
    },
    exitAddAreaMode() {
        this.$data.addAreaMode = false;
        this.$data.countiesLoaded = false;
        this.$data.countriesLoaded = false;
    },
    enterAddAreaMode() {
        this.$data.addAreaMode = true;
        this.$data.allowAreaSave = false;
        // get the counties and countries data
        getCounties(this.$http)
            .then((response) => {
                this.$data.counties = response.counties;
                this.$data.countiesLoaded = true;
                return getCountries(this.$http)
            })
            .then((response) => {
                this.$data.countries = response.countries;
                this.$data.countriesLoaded = true;
                this.$data.allowAreaSave = true;
            })
            .catch ((err) => {
                console.error(err);
            });
    },
    deleteGroup() {
        this.clearAlerts();

        let headersObj = getHTTPHeaders();
        this.$http.delete('company/'+this.$data.group.id,headersObj)
        .then((response) => {
            console.log(response.data);
            if (response.data.success == true) {
                this.$data.groupSaveInProgress = false;
                this.$data.groupSaveSuccess = true;
                this.$data.groupSaveError = false;
                this.goBack();
            }
            else {
                // data error
                this.$data.groupSaveInProgress = false;
                this.$data.groupSaveSuccess = false;
                this.$data.groupSaveError = true;
            }
        })
        .catch ((err) => {
            console.error(err);
            this.$data.groupSaveInProgress = false;
            this.$data.groupSaveSuccess = false;
            this.$data.groupSaveError = false;
        });
    },
    updateGroup() {
        this.clearAlerts();
        this.$data.groupSaveInProgress = true;
        let headersObj = getHTTPHeaders();

        const formData = new FormData();
        let payload = {
            id: this.$data.group.id,
            company_name: this.$data.group.company_name,
            company_short_name: this.$data.group.company_short_name,
            main_contact_number: this.$data.group.main_contact_number,
            main_email: this.$data.group.main_email,
            main_address: this.$data.group.main_address,
            main_post_code: this.$data.group.main_post_code,
            main_town: this.$data.group.main_town,
            county_id: this.$data.group.county_id,
            country_id: this.$data.group.country_id,
            sub_domain: this.$data.group.sub_domain,
            licence_id: this.$data.group.licence_id,
            is_sap: this.$data.group.is_sap,
            is_active: this.$data.group.is_active,
            logo: this.$data.group.logo,
            notes: this.$data.group.notes
        }

        for (let key in payload) {
          formData.append(key, payload[key])
        }

        formData.append('_method', 'PUT');

        this.$http.post('company/'+this.$data.group.id, formData,headersObj)
        .then((response) => {
            console.log(response.data);
            if (response.data.success == true) {
                this.$data.groupSaveInProgress = false;
                this.$data.groupSaveSuccess = true;
                this.$data.groupSaveError = false;
            }
            else {
                // data error
                this.$data.groupSaveInProgress = false;
                this.$data.groupSaveSuccess = false;
                this.$data.groupSaveError = true;
            }
        })
        .catch ((err) => {
            console.error(err);
            this.$data.groupSaveInProgress = false;
            this.$data.groupSaveSuccess = false;
            this.$data.groupSaveError = false;
        });
    },
    saveArea() {
        this.clearAlerts();
        this.$data.areaSaveInProgress = true;
        let headersObj = getHTTPHeaders();
        console.log(headersObj);

        const formData = new FormData();
        let payload = {
            area_name: this.$data.newArea.area_name,
            company_id: this.$data.group.id,
            contact_first_name: this.$data.newArea.contact_first_name,
            contact_last_name: this.$data.newArea.contact_last_name,
            contact_no: this.$data.newArea.contact_no,
            email: this.$data.newArea.email,
            address: this.$data.newArea.address,
            post_code: this.$data.newArea.post_code,
            post_town: this.$data.newArea.post_town,
            county_id: this.$data.newArea.county_id,
            country_id: this.$data.newArea.country_id,
            logo: this.$data.newArea.logo,
            is_active: 1
        }

        for (let key in payload) {
          formData.append(key, payload[key])
        }

        this.$http.post('area', formData, headersObj)
        .then((response) => {
            console.log(response.data);
            if (response.data.success == true) {
                this.$data.areaSaveInProgress = false;
                this.$data.areaSaveError = false;
            }
            else {
                // data error
                this.$data.areaSaveInProgress = false;
                this.$data.areaSaveError = true;
            }
        })
        .catch ((err) => {
            console.error(err);
            this.$data.areaSaveInProgress = false;
            this.$data.areaSaveError = false;
        });
    },
    setIsSAP(isSap) {
        // get confirmation of active/inactive
        this.$data.group.is_sap = (isSap === '1' ? '0' : '1');
        console.log(this.$data.group.is_sap);

    },
    setIsActive(isActive) {
        // get confirmation of active/inactive
        this.$data.group.is_active = (isActive === '1' ? '0' : '1');

    },
  }
}
</script>

<style scoped>

    .toggle-group-button {
        position: absolute;
        right: 5%;
        top: 15%;
    }
    .group-active {
        color: #4dbd74!important;
    }
    .group-disabled {
        color: #f86c6b!important;
    }
    p.action-button-toolbar button {
        margin-right: 5px;
    }
    .header-collapse {
        text-align: left;
        padding: 0;
        background-color: #f0f3f5;
        border: 0;
    }
    .header-collapse:focus, .header-collapse:active {
        box-shadow: none;
    }
</style>
